// src/components/AddDebtModal.js

import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress } from '@mui/material';
import { db } from '../firebase';
// GÜNCELLENDİ: runTransaction, doc, collection, addDoc, serverTimestamp import edildi
import { collection, addDoc, serverTimestamp, doc, runTransaction } from 'firebase/firestore';

const AddDebtModal = ({ isOpen, onClose, customerId, customerName }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // GÜNCELLENDİ: handleSubmit (Artık 'customers' belgesini de güncelliyor)
  const handleSubmit = async () => {
    const debtAmount = parseFloat(amount);
    if (!debtAmount || debtAmount <= 0) {
      alert('Lütfen geçerli bir tutar giriniz.');
      return;
    }
    setIsSaving(true);
    
    // Güncellenecek ana müşteri belgesi
    const customerRef = doc(db, "customers", customerId);
    // Yeni borç kaydının ekleneceği koleksiyon
    const transactionColRef = collection(db, "transactions");

    try {
      // İşlemi Transaction (atomik) olarak gerçekleştir
      await runTransaction(db, async (transaction) => {
        const customerDoc = await transaction.get(customerRef);
        if (!customerDoc.exists()) {
          throw "Müşteri belgesi bulunamadı!";
        }

        const customerData = customerDoc.data();

        // 1. Müşteri (customers) belgesini güncelle
        const newToplamSatis = (customerData.toplamSatis || 0) + debtAmount;
        const newToplamBakiye = (customerData.toplamBakiye || 0) + debtAmount; // Borç eklenince bakiye (borç) artar

        transaction.update(customerRef, {
          toplamSatis: newToplamSatis,
          toplamBakiye: newToplamBakiye
        });

        // 2. Yeni borç kaydını 'transactions' koleksiyonuna ekle
        // Not: addDoc transaction içinde doğrudan kullanılamaz, bu yüzden doc(collectionRef) ile
        // yeni bir referans oluşturup .set() kullanıyoruz.
        const newTransactionRef = doc(transactionColRef);
        transaction.set(newTransactionRef, {
          customerId: customerId,
          customerName: customerName,
          type: "borc",
          amount: debtAmount,
          description: description || "Genel Borçlandırma",
          timestamp: serverTimestamp()
        });
      });

      alert('Borç kaydı başarıyla eklendi ve müşteri bakiyesi güncellendi.');
      onClose();
    } catch (error) {
      console.error("Borç eklenirken hata: ", error);
      alert(`Bir hata oluştu: ${error.message}`);
    } finally {
      setIsSaving(false);
      setAmount('');
      setDescription('');
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Borç Ekle: {customerName}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Tutar (₺)" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} required autoFocus />
          <TextField label="Açıklama" value={description} onChange={(e) => setDescription(e.target.value)} multiline rows={2} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
          {isSaving ? <CircularProgress size={24} /> : 'Borcu Kaydet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDebtModal;